import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTasks, faPen } from '@fortawesome/free-solid-svg-icons';
import type { CaseTask } from '../../../types/caseFile';
import s from '../CaseFilePage.module.css';

interface TasksTableProps {
  tasks: CaseTask[];
  currentUserId: string | undefined;
  openEditTask: (task: CaseTask) => void;
  fmtUKDate: (val: unknown) => string;
}

function taskStatusClass(status: string): string {
  const lower = (status || '').toLowerCase();
  if (lower === 'completed') return s.statusCompleted;
  if (lower === 'in progress') return s.statusInProgress;
  if (lower === 'overdue') return s.statusOverdue;
  return s.statusDefault;
}

export default function TasksTable({
  tasks,
  currentUserId,
  openEditTask,
  fmtUKDate,
}: TasksTableProps) {
  return (
    <div className={s.section}>
      <div className={s.sectionHeader}>
        <h3>
          <FontAwesomeIcon icon={faTasks} /> Ongoing Tasks
        </h3>
        <span className={s.badge}>{tasks.length}</span>
      </div>

      {tasks.length === 0 ? (
        <p className={s.emptyMsg}>No tasks for this case.</p>
      ) : (
        <div className={s.tableScroll}>
          <table className={s.dataTable}>
            <thead>
              <tr>
                <th>Created By</th>
                <th>Assigned To</th>
                <th>Task</th>
                <th>Deadline</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((t) => (
                <tr key={t.TaskID}>
                  <td>{t.from_display_name}</td>
                  <td>{t.assigned_display_name}</td>
                  <td>{t.Description}</td>
                  <td>{fmtUKDate(t.Deadline)}</td>
                  <td>
                    <span className={`${s.statusPill} ${taskStatusClass(t.Status)}`}>
                      {t.Status}
                    </span>
                  </td>
                  <td>
                    {currentUserId === t.user_id && (
                      <button
                        className={s.iconBtn}
                        onClick={() => openEditTask(t)}
                        title="Edit task"
                      >
                        <FontAwesomeIcon icon={faPen} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
